export default __webpack_public_path__ + "static/media/2.aa64185e.jpg";